import React from "react";
import { Instagram, Linkedin, Mail, MessageCircle } from "lucide-react";
export default function Footer() {
  return (
    <footer className="pt-20 pb-10 border-t border-border bg-background" data-testid="footer">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="font-display text-2xl text-gold-gradient mb-3">Juliano Wagner</div>
            <p className="text-sm text-muted-foreground max-w-sm leading-relaxed">Minha missão é alavancar o crescimento patrimonial de meus clientes democratizando o acesso às soluções financeiras mais sofisticadas do mercado com transparência, organização e metodologia comprovada.</p>
            <div className="flex gap-3 mt-6">
              <a href="https://wa.me/5551991558880" className="w-10 h-10 rounded-full border border-border hover:border-primary flex items-center justify-center text-muted-foreground hover:text-primary transition" aria-label="WhatsApp"><MessageCircle size={16} /></a>
              <a href="mailto:juliano@julianowagner.com.br" className="w-10 h-10 rounded-full border border-border hover:border-primary flex items-center justify-center text-muted-foreground hover:text-primary transition" aria-label="Email"><Mail size={16} /></a>
              <a href="https://instagram.com/julianowagnerr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-border hover:border-primary flex items-center justify-center text-muted-foreground hover:text-primary transition" aria-label="Instagram @julianowagnerr"><Instagram size={16} /></a>
              <a href="https://www.linkedin.com/in/julianowagnerr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-border hover:border-primary flex items-center justify-center text-muted-foreground hover:text-primary transition" aria-label="LinkedIn Juliano Wagner"><Linkedin size={16} /></a>
            </div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-primary mb-4">Navegação</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#como-funciona" className="hover:text-primary">Processo</a></li>
              <li><a href="#vantagens" className="hover:text-primary">Vantagens</a></li>
              <li><a href="#faq" className="hover:text-primary">FAQ</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-primary mb-4">Credenciais</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>ANCORD</li><li>Ademicon Novo Hamburgo</li><li>Banco Central</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between text-xs text-muted-foreground gap-3">
          <div>© {new Date().getFullYear()} Juliano Wagner · Patrimônio & Consórcio Imobiliário</div>
          <div>Porto Alegre · RS — Brasil</div>
        </div>
      </div>
    </footer>
  );
}
